import { Avatar } from '@/components/Avatar'
import { Button } from '@/components/Button'
import styles from './RelationManagerChatHeader.module.css'

interface RelationManagerChatHeaderProps {
  testId?: string
  displayName: string
  avatarUrl?: string | null
  scheduleCallLink?: string | null
  lastSeenAt?: string | null
}

export function RelationManagerChatHeader({
  avatarUrl,
  displayName,
  scheduleCallLink,
  lastSeenAt,
}: RelationManagerChatHeaderProps) {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <Avatar subject={{ displayName, avatarUrl }} />

        <div className={styles.agent}>
          <div className={styles.header}>
            <span className={styles.agentName}>{displayName} (RM)</span>
            {scheduleCallLink && (
              <div className={styles.separator}>
                <Button
                  target="_blank"
                  variant="text-inline"
                  href={scheduleCallLink}
                  label="Schedule a Call"
                />
              </div>
            )}
          </div>
          <div className={styles.lastSeen}> {lastSeenAt}</div>
        </div>
      </div>
    </div>
  )
}
